<template>
	<div class="gap">
		<div v-if="receipt" class="column content">
			<!-- <nav class="breadcrumb">
				<router-link to="/subscriptions?active=receipts"><i class="fas fa-arrow-left"></i> Subscriptions &amp; Payments</router-link>
			</nav>
			<aside class="overlay updating" v-if="paymentStatus.loading && !receipt">
				<i class="fa fa-spinner fa-spin"></i>
				Loading&hellip;
			</aside> -->
			<header class="row centering separated">
				<router-link class="rigid" to="/payments"><i class="fas fa-arrow-left"></i></router-link>
				<h1 class="rigid">{{receipt.createdDate | date}} Receipt</h1>
			</header>
			<aside class="overlay updating" v-if="paymentStatus.loading && !receipt">
				<i class="fa fa-spinner fa-spin"></i>
				Loading&hellip;
			</aside>
			<div class="column rigid payment-receipt" v-if="receipt">
				<header>
					<div class="billing-address vcard">
						<address class="adr">
							<div class="org">Tektronix, Inc.</div>
							<div class="street-address">14150 SW Karl Braun Drive</div>
							<div><span class="locality">Beaverton</span>, <abbr title="Oregon" class="region">OR</abbr> <span class="postal-code">97077</span> <span class="country-name">USA</span></div>
						</address>
					</div>

					<h1>Billing Receipt</h1>

					<table class="table-fixed table-props">

						<tr>
							<th>Payee</th>
							<td>
								<tr>
									<td>{{ userName || user.subscriptionCode || 'me' }}</td>
								</tr>
								<tr>
									<td>{{ address && address.organization }}</td>
								</tr>
							</td>
						</tr>

						<tr v-if="address.addressLine1">
							<th>Ship To</th>
							<td>
								<tr>
									<td>{{address.addressLine1}}</td>
								</tr>
								<tr v-if="address.addressLine2">
									<td>{{address.addressLine2}}</td>
								</tr>
								<tr>
									<td><span class="locality">{{address.city}}</span>, <abbr class="region">{{address.state}}</abbr> <span class="postal-code">{{address.postalCode}}</span> <span class="country-name">{{address.country}}</span></td>
								</tr>
							</td>
						</tr>

						<tr>
							<th>Issued</th>
							<td><time>{{ receipt.createdDate | date('long') }}</time></td>
						</tr>

						<tr>
							<th>Status</th>
							<td>
								<span v-if="receipt.isPaid">
									<i class="fa fa-check"></i>
									Paid
								</span>
								<span v-if="receipt.paymentFailed && !receipt.overdue">
									<i class="fa fa-times"></i>
									Payment Failed
								</span>
								<span v-if="(!receipt.isPaid && receipt.overdue)">
									<i class="fa fa-times"></i>
									Unpaid
								</span>
								<span v-if="!receipt.isPaid && !receipt.overdue && !receipt.paymentFailed">
									No Payment Necessary
								</span>
							</td>
						</tr>

					</table>


				</header>
				<div class="itemized-list" v-if="receipt.items.length > 0">
					<h2> Electronically Downloaded Items </h2>
					<table class="table-receipt table-fixed">
						<thead>
							<tr>
								<th class="col-quantity"><acronym title="Quantity">Qty.</acronym></th>
								<th class="col-description" colspan="2">Description</th>
								<th class="col-amount">Amount</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in receipt.items" :key="index">
								<td class="col-quantity">{{ item.quantity || 1 }}</td>
								<td class="col-description" colspan="2">{{ item.description }}</td>
								<td class="col-amount">{{ item.amount | currency }}</td>
							</tr>
						</tbody>
						<tfoot>
							<tr class="receipt-subtotal">
								<td class="col-quantity">{{ receipt.items.length || 0 }}</td>
								<th class="col-description">Items</th>
								<th class="col-amount-label">Subtotal</th>
								<td class="col-amount">{{ receipt.subtotal | currency }}</td>
							</tr>
							<tr class="receipt-credit-tend" v-if="receipt.coupon &amp;&amp; receipt.coupon.discount">
								<th class="col-amount-label" colspan="3">Coupon</th>
								<td class="col-amount">{{ receipt.coupon.discount | currency }}</td>
							</tr>
							<tr class="receipt-credit-tend" v-if="receipt.tax">
								<th class="col-amount-label" colspan="3">Tax</th>
								<td class="col-amount">{{ receipt.tax | currency }}</td>
							</tr>
							<tr class="receipt-credit-tend" v-if="receipt.creditTendered">
								<th class="col-amount-label" colspan="3">Credit</th>
								<td class="col-amount">{{ receipt.creditTendered | currency }}</td>
							</tr>
							<tr class="receipt-payment-tend">
								<th class="col-amount-label" colspan="3">Total</th>
								<td class="col-amount">{{ receipt.amount | currency }}</td>
							</tr>

							<tr class="receipt-payment-tend" v-if="receipt.amount > 0 &amp;&amp; (receipt.cardBrand || receipt.cardLast4)">
								<th class="col-amount-label" colspan="3">Paid With</th>
								<td class="col-amount">{{ receipt.cardBrand }} {{ receipt.cardLast4 }}</td>
							</tr>
						</tfoot>
					</table>
				</div>
				<div class="empty" v-if="receipt.items.length === 0">
				(No Items)
				</div>

				<footer>
					<div>
						Processed
						<time v-if="receipt.processedDate">{{ receipt.processedDate | date('medium') }}</time>
					</div>
				</footer>

			</div>

		</div>
		<div v-else class="colum content">
			<header class="row centering separated">
				<router-link class="rigid" to="/payments"><i class="fas fa-arrow-left"></i></router-link>
				<h1 class="rigid">No Receipt found</h1>
			</header>
		</div>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import date from '../../filters/date';
import currency from '../../filters/currency';

export default {
	name: 'TektronixReceipt',

	created() {
		this.$store.dispatch('payment/GET_RECEIPTS_REQUEST');
	},
	filters: {
		date,
		currency
	},
	computed: {
		...mapGetters('payment', [
			'receipts',
			'paymentStatus',
		]),
		...mapGetters([
			'user'
		]),
		userName(){
			return this.user.address ? (this.user.address.firstName + ' ' + this.user.address.lastName) : this.user.email;
		},
		address(){
			return this.user.address || {};
		},
		receipt() {
			const id = this.$route.params.id;
			return this.receipts.find((receipt) => {
				return receipt.id === id || receipt.chargeId === id;
			});
		}
	}
};

</script>



// WEBPACK FOOTER //
// ./src/views/receipts/Tektronix.vue